export default class SlickSliderSettings {
  constructor(settings) {
    this.desktop = settings.desktop
    this.tablet = settings.tablet
    this.mobile = settings.mobile
  }

  get maxWidth() {
    return Math.max(
      1400 / (this.desktop || 6),
      800 / (this.tablet || 4),
      600 / (this.mobile || 2)
    )
  }

  get mobileMaxWidth(){
    return 600 / (this.mobile || 2)
  }

  get slidesToShow() {
    return this.desktop || 7
  }

  get slidesToScroll() {
    return this.desktop || 7
  }

  get responsiveBreakpoints() {
    return [
      { breakpoint: 1400, settings: { slidesToShow: this.desktop || 6, slidesToScroll: this.desktop || 6 } },
      { breakpoint: 1200, settings: { slidesToShow: this.desktop || 5, slidesToScroll: this.desktop || 5 } },
      { breakpoint: 1000, settings: { slidesToShow: this.desktop || 4, slidesToScroll: this.desktop || 4 } },
      { breakpoint: 800, settings: { slidesToShow: this.tablet || 3, slidesToScroll: this.tablet || 3 } },
      { breakpoint: 600, settings: { slidesToShow: this.mobile || 2, slidesToScroll: this.mobile || 2, className: 'mobile' } }
    ]
  }
}
